import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Badge } from 'react-bootstrap';

import './RecentSearch.css';

const I18n = require('i18n-react').default;

const propTypes = {
  flights: PropTypes.arrayOf(
    PropTypes.shape({
      flightOrigin: PropTypes.shape({
        code: PropTypes.string.isRequired
      }).isRequired,
      flightDestiny: PropTypes.shape({
        code: PropTypes.string.isRequired
      }).isRequired
    })
  ).isRequired,
  clickCallback: PropTypes.func.isRequired
};

class RecentSearch extends React.Component {
  render() {
    return (
      <Row id="componentRecentSearch">
        <Col xs={12} className="recentSearch">
          <span className="recentSearchText">
            {I18n.translate('components.recentSearch.title')}
          </span>
          {this.props.flights.map((flight, index) => {
            return (
              <Badge
                key={index}
                className="flightBadge"
                id={`btnFlightBadge-${index}`}
                onClick={() => this.props.clickCallback(flight)}>
                <span>{flight.flightOrigin.code}</span>
                <span className="flightIcon" />
                <span>{flight.flightDestiny.code}</span>
              </Badge>
            );
          })}
        </Col>
      </Row>
    );
  }
}

RecentSearch.propTypes = propTypes;

export default RecentSearch;



// WEBPACK FOOTER //
// ./src/components/searchBox/recentSearch/RecentSearch.jsx